export default __webpack_public_path__ + "static/media/checked-icon.93563ab7.svg";